module.exports = __webpack_public_path__ + "assets/img/section-1-part-3-landing-page-bg.cb099910.jpg";